<template>
  <main-layout>
    <iframe
      sandbox="allow-popups allow-forms allow-same-origin allow-scripts allow-top-navigation allow-downloads"
      allowfullscreen="true"
      :src="src"
      :style="{
        display: 'block',
        border: 'none',
        position: 'absolute',
        width: '100%',
        height: 'calc(100dvh - var(--nav-height))'
      }"
    />
  </main-layout>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters(['currentLang']),
    src() {
      if (!this.currentLang) return ''
      return `https://event-tracking.zwiz.app/${this.currentLang}`
    }
  },
  mounted() {
    window.addEventListener('message', this.handleMessage)
  },
  beforeDestroy() {
    window.removeEventListener('message', this.handleMessage)
  },
  methods: {
    handleMessage(event) {
      const { id, value } = event.data
      switch (id) {
        case 'copy': {
          if (value) {
            navigator.clipboard.writeText(value)
          }
          break
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/EventTracking/index.vue